import { ReactElement, createContext, useContext, useState } from 'react';
import { AppAndInstanceSwitcherContext } from './app-and-instance-switcher';

type KeyToggleContextValue = {
  showKeys: boolean;
  toggleKeys: () => void;
  isActive: boolean;
};

const defaultValue = {
  showKeys: false,
  toggleKeys: () => void 0,
  isActive: false
};

/**
 * Used to manage state for toggling key visibility in code blocks. See `lib/docs/components/inject-keys.tsx` and `lib/docs/components/code-block.tsx` for usage.
 */
export const KeyToggleContext =
  createContext<KeyToggleContextValue>(defaultValue);

export const KeyToggleProvider = ({ children }: { children: ReactElement }) => {
  const [showKeys, setShowKeys] = useState(false);
  const { currentInstance } = useContext(AppAndInstanceSwitcherContext);

  return (
    <KeyToggleContext.Provider
      value={{
        showKeys,
        toggleKeys: () => setShowKeys(cur => !cur),
        isActive: Boolean(currentInstance)
      }}
    >
      {children}
    </KeyToggleContext.Provider>
  );
};
